import {Orgfield, Personfield} from 'app/main/pages/edit-template/edit-template.dto';


export enum OrganizationEnum {
    "Organization" = "name",
    "Reg no" = "register_no",
    "Phone no" = "phone",
    "Address" = "address",
    "Zip code" = "zipcode",
    "City" = "city",
}

export enum RecipientEnum {
    "First name" = "firstname",
    // eslint-disable-next-line @typescript-eslint/no-duplicate-enum-values
    "Full name" = "firstname",
    "Last name" = 'lastname',
    "Email" = "email",
    "Phone no" = "phone_no",
    "Personal ID number" = "persnol_no",
    "Address" = "address",
    "Zip code" = "zipcode",
    "City" = "city"
}

/**
 * set the recipient fields from perosn fields
 * @param personFields
 * @param hidden
 * @returns
 */
export function setRecipientData(personFields: Partial<Personfield>[], hidden:boolean = false):Partial<Personfield> {
    let recipient = {};
     if(Array.isArray(personFields)) {
        for (const field of personFields) {
            if (typeof RecipientEnum[field.name] != 'undefined') {
                if (hidden && field.is_enable === 0) continue;
                let value = field?.value;
                if (field?.key === "phone_no" && value && value['e164Number']) {
                    value = value['e164Number'];
                }
                recipient = {...recipient, ...{[RecipientEnum[field.name]]: value}};
            }
         }
    }
    return recipient;
}

export function setOrgnizationData(orgField: Orgfield[], hidden:boolean = false) {
    let organization: { [key: string|number]: string|number } = {};
    if (Array.isArray(orgField)) {
        for (const field of orgField) {
            if (typeof OrganizationEnum[field.name] != 'undefined') {
                const fieldValue = typeof field.value == 'object' ? field?.value?.name : field.value;
                if (hidden && field.is_enable === 0) continue;
                organization = {...organization, ...{[OrganizationEnum[field.name]]: fieldValue ?? ''}};
            }
        }
    }
    return organization;
}
